import './assets/scss/style.scss';
import { ApiService } from './app/services/api.service';

const api = ApiService.getInstance();
api.createPublicObject();
